import template from './news.html';
import controller from './news.controller';
import './news.scss';

let newsComponent = {
  bindings: {},
  template,
  controller
};

export default newsComponent;



// WEBPACK FOOTER //
// ./client/app/components/news/news.component.js